import React from 'react';
import { Toast } from 'antd-mobile';
import {post} from '../../utils/request';
import api from './api';
import Circle from '../modules/circle/index';
import './index.less';
function compare(val1,val2){
  return val2.deliveryCarPer-val1.deliveryCarPer;
};
function compare2(val1,val2){
  return val2.deliveryCarCnt-val1.deliveryCarCnt;
};
class DataScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      statisticsAllData: {},
      zuLingData:[],
      zuLing:'',
      zuShouData:[],
      zuShou:'',
      muBiaoRight: 0,
      muBiaoLeft: 0
    }
  }
  componentWillMount() {
    const search = window.location.hash.split('?')[1];
    if(!search){
      Toast.info('当前版本过低，请升级APP',9999);
      return
    }
    const access_token = search.split('=')[1];
    if(!access_token){
      Toast.info('当前版本过低，请升级APP',9999);
      return
    }

    this.statisticsAll(access_token);
    // 获取租赁数据
    this.statisticsDeliveryCar({
      type: '租售',
      endDate: '2021-01-31 23:59:59',
      owerShips: '4,5',
    },
    access_token,
    data=>{
      var tongJi = '',muBiao = 0;
      let a = [];
      data.map(item=>{
        if(item.city === '总计'){
          tongJi = item.deliveryCarCnt;
          muBiao = item.deliveryCarTargetCnt;
        }else{
          a.push(item);
        }
      });
      a.sort(compare);
      this.setState({
        zuLingData: a,
        zuLing: tongJi,
        muBiaoLeft: muBiao
      }, ()=>{
        // 获取租售数据
        this.statisticsDeliveryCar({
          type: '租赁',
          dateType: 'gmt_create',
          startDate: '2020-09-01 00:00:00',
          endDate: '2021-01-31 23:59:59',
          // owerShips: '4,5',
        },
        access_token,
        data=>{
          var tongJi = '',muBiao = 0;
          let a = [];
          data.map(item=>{
            if(item.city === '总计'){
              tongJi = item.deliveryCarCnt;
              muBiao = item.deliveryCarTargetCnt;
            }else{
              a.push(item);
            }
          });
          a.sort(compare2);
          this.setState({
            zuShouData: a,
            zuShou: tongJi,
            muBiaoRight: muBiao
          },()=>{
            // 获取邮政数据
            // this.querySelectBdDictionaryList(access_token);
          });
        });
      });
    });
  }

  statisticsAll(access_token) {
    post({
      url: api.statisticsAll + '?access_token=' + access_token, 
      data: {
        // owerShips: '4,5',
        dateType: 'gmt_create',
        startDate: '2020-09-01 00:00:00',
        endDate: '2021-01-31 23:59:59'
      }
    }).then((res) => {
      if(!(res && res.data)) {
        return;
      }
      this.setState({
        statisticsAllData: res.data
      });
    });
  }
  statisticsDeliveryCar(ops, access_token, fn){
    post({
      url: api.statisticsDeliveryCar + '?access_token=' + access_token, 
      data: ops
    }).then((res) => {
      if(!(res && res.data)) {
        return;
      }
      fn(res.data);
    });
  }
  querySelectBdDictionaryList(access_token){
    const {zuLingData, zuShouData} = this.state;
    var a = zuLingData,b = zuShouData;
    post({
      url: api.querySelectBdDictionaryList + '?access_token=' + access_token, 
      data: {
        parentDictionaryCode: 'HICSCREENCHINAPOST',
      }
    }).then((res) => {
      if(!(res && res.data)) {
        return;
      }
      res.data.map(item=>{
        if(item.dictionaryName === '城市租赁情况'){
          a.push({
            city: "邮政",
            deliveryCarCnt: item.description.split(',')[0],
            deliveryCarTargetCnt: item.description.split(',')[1],
            deliveryCarPer: item.description.split(',')[2],
          });
        }else{
          b.push({
            city: "邮政",
            deliveryCarCnt: item.description.split(',')[0],
            deliveryCarTargetCnt: item.description.split(',')[1],
            deliveryCarPer: item.description.split(',')[2],
          });
        }
      });
      this.setState({
        zuLingData: a,
        zuShouData: b
      });
    });
  }

  leftHtml(){
    const {zuLingData} = this.state;
    let html = '';
    
    return (<ul className="progress">
      html
    </ul>);
  }

  
  
  render() {
    const { hlThreadCnt,signCustomerCnt,signCarCnt,deliveryCarCnt,todayHlThreadCnt,todaySignCustomerCnt,todaySignCarCnt,todayDeliveryCarCnt } = this.state.statisticsAllData;
    const {zuLing, zuShou, zuLingData, zuShouData, muBiaoLeft, muBiaoRight} = this.state;
    let zlbl = zuLing/muBiaoLeft, zsbl = zuShou/muBiaoRight;
    return (
      <div className="DataScreenBox">
        <div className="DataScreen_block">
            <div className="title-h1">
              <div className="leftBox">
                渡江战役数据统计
              </div>
              <div className="rightBox">单位：台</div>
            </div>
            <div className="content col-2">
              <div>
                <div className="title-h2">2660运营目标</div>
                <div className="circleBox">
                  <Circle
                    id="circle1"
                    circleBottomColor="#F4F5F5"
                    innerColorStart="#079FFF"
                    innerColorEnd="#079FFF"
                    lineW="20"
                    width="260"
                    height="260"
                    percent={zlbl}
                  />
                  <div className="text">
                    {zuLing}
                    <p>/{muBiaoLeft}</p>
                  </div>
                </div>
                <ul className="progress">
                  {zuLingData.map(item=>{
                    if(item.city === '邮政'){
                      return (<li key={item.city}>
                        <div className="progress-title">
                          <div className="left">
                            <i></i>
                            {item.city}
                          </div>
                          <div className="right">
                            {item.deliveryCarCnt}
                            <span>/{item.deliveryCarTargetCnt}</span>
                          </div>
                        </div>
                        <div className="now-progress">
                          <div className="blue" style={{width: `${item.deliveryCarPer*100}%`}}></div>
                        </div>
                      </li>)
                    }else{
                      return (<li key={item.city}>
                        <div className="progress-title">
                          <div className="left">{item.city}</div>
                          <div className="right">
                            {item.deliveryCarCnt}
                            <span>/{item.deliveryCarTargetCnt}</span>
                          </div>
                        </div>
                        <div className="now-progress">
                          <div className="blue" style={{width: `${item.deliveryCarPer*100}%`}}></div>
                        </div>
                      </li>)
                    }
                  })}
                </ul>
              </div>
              <div>
                <div className="title-h2">520交付目标</div>
                <div className="circleBox">
                  <Circle
                    id="circle2"
                    circleBottomColor="#F4F5F5"
                    innerColorStart="#FFAF07"
                    innerColorEnd="#FFAF07"
                    lineW="20"
                    width="260"
                    height="260"
                    percent={zsbl}
                  />
                  <div className="text">
                    {zuShou}
                    <p>/{muBiaoRight}</p>
                  </div>
                </div>
                <ul className="progress">
                  {zuShouData.map(item=>{
                      if(item.city === '邮政'){
                        return (<li key={item.city}>
                          <div className="progress-title">
                            <div className="left">
                              <i></i>
                              {item.city}
                            </div>
                            <div className="right">
                              {item.deliveryCarCnt}
                            </div>
                          </div>
                          <div className="now-progress">
                            <div className="orange" style={{width: `${item.deliveryCarPer*100}%`}}></div>
                          </div>
                        </li>)
                      }else{
                        return (<li key={item.city}>
                          <div className="progress-title">
                            <div className="left">{item.city}</div>
                            <div className="right">
                              {item.deliveryCarCnt}
                              <span>/{item.deliveryCarTargetCnt}</span>
                            </div>
                          </div>
                          <div className="now-progress">
                            <div className="orange" style={{width: `${item.deliveryCarCnt/250*100}%`}}></div>
                          </div>
                        </li>)
                      }
                    })}
                </ul>
              </div>
            </div>
        </div>
        <div className="DataScreen_block">
            <div className="title-h1">
              <div className="leftBox">
                节点跟进
              </div>
            </div>
            <div className="content col-4">
              <div>
                <div>
                  <div className="title-h3">
                    线索
                  </div>
                  <div className="num">
                    {hlThreadCnt || 0}
                  </div>
                  <div className="newNum">
                    今日新增:{todayHlThreadCnt || 0}
                    {!todayHlThreadCnt || todayHlThreadCnt == 0 ? '' : (<i></i>)}
                  </div>
                </div>
              </div>
              <div>
                <div>
                  <div className="title-h3">
                    签约客户
                  </div>
                  <div className="num">
                    {signCustomerCnt || 0}
                  </div>
                  <div className="newNum">
                    今日新增:{todaySignCustomerCnt || 0}
                    {!todaySignCustomerCnt || todaySignCustomerCnt == 0 ? '' : (<i></i>)}
                  </div>
                </div>
              </div>
              <div>
                <div>
                  <div className="title-h3">
                    签约车辆
                  </div>
                  <div className="num">
                    {signCarCnt}
                  </div>
                  <div className="newNum">
                    今日新增:{todaySignCarCnt}
                    {!todaySignCarCnt || todaySignCarCnt == 0 ? '' : (<i></i>)}
                  </div>
                </div>
              </div>
              <div>
                <div>
                  <div className="title-h3">
                    租赁交付
                  </div>
                  <div className="num">
                    {deliveryCarCnt}
                  </div>
                  <div className="newNum">
                    今日新增:{todayDeliveryCarCnt}
                    {!todayDeliveryCarCnt || todayDeliveryCarCnt == 0 ? '' : (<i></i>)}
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    );
  }
}

export default DataScreen;


// WEBPACK FOOTER //
// ./src/dataScreen/index/index.js